import React from 'react';

export const LouisianaInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">City of New Orleans</p>
        <p className="eds-l-mar-bot-1">
            <strong>Grants for Gig Economy Workers</strong> |&nbsp;
            <a
                href="https://www.nolaba.org/relief-fund/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>$500 - $1,000 grants per approved gig economy worker.</p>
    </div>
);
